module.exports = __webpack_public_path__ + "img/bomb.185c1ec9.png";